/* global axios */

import ApiClient from './ApiClient';

class Agents extends ApiClient {
  constructor() {
    super('agents', { accountScoped: true });
  }

  bulkInvite({ emails }) {
    return axios.post(`${this.url}/bulk_create`, {
      emails,
    });
  }

  resetPassword(agentId) {
    return axios.post(`${this.url}/${agentId}/reset_password`);
  }
}

export default new Agents();
